import { z } from 'zod';

export const ZeePersonaDataFormSchema = z.object({
  age: z.number().min(18, { message: 'Age must be at least 18' }).optional(),
  gender: z.string().optional(),
  marital_status: z.string().optional(),
  education: z.string().optional(),
  rentorhomeowner: z.string().optional(),
  behaviors: z.array(z.string()).optional().default([]),
  interests: z.array(z.string()).optional().default([]),
  personality: z.array(z.string()).optional().default([]),
  children_between_ages_0_3: z
    .number()
    .min(0, { message: 'Must be 0 or greater' })
    .optional(),
  children_age_ranges: z.array(z.string()).optional().default([]),
});

export default ZeePersonaDataFormSchema;
